import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { GetAllOldProtocol, resetGetAllStatus } from "./slice"

export function Pre2015List() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const oldProtocolState = useAppSelector(state => state.pre0215)

    useEffect(() => {
        dispatch(GetAllOldProtocol({ itemsPerPage: 0, page: 0, customer: sessionState.selected.customerId! }))
    }, [])

    useEffect(() => {
        if (oldProtocolState.oldProtocolResponseStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [oldProtocolState.oldProtocolResponseStatus])

    if (oldProtocolState.oldProtocolResponseStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    const oldProtocols = oldProtocolState.oldProtocolResponse?.data || []

    return (
        <div className="w-full p-6">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Protocollo</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegato</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Codifica</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Protocollo Informatico</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            oldProtocols.map((oldP, index) =>
                                <tr
                                    key={oldP.id || index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-semibold">{oldP.protocolNumber}</td>
                                    <td className="px-3 py-2 text-neutral-700">{oldP.entryProtocolAttachmentDescription}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{oldP.entryProtocolAttachmentCoding}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{oldP.id}</td>
                                </tr>
                            )
                        }
                        {
                            oldProtocols.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="px-4 py-6 text-center text-sm text-neutral-500 bg-white">
                                        Nessun protocollo pre2015 disponibile per il cliente selezionato.
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}